import { render, staticRenderFns } from "./ReservationsCasa.vue?vue&type=template&id=49483e9a&scoped=true"
import script from "./ReservationsCasa.vue?vue&type=script&lang=js"
export * from "./ReservationsCasa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49483e9a",
  null
  
)

export default component.exports